<div class="container my-3">
  <casi-search-debounced></casi-search-debounced>
  <hr>
  <casi-counter [counter]="counter"> </casi-counter>
  <h3>Current value of the counter {{cnt()}}</h3>
  <h3>10x counter: {{derivedCnt()}}</h3>
  <h3>counter service: {{counterService.counter()}}</h3>

  <button (click)="onIncrement()">Increment</button>
  <button (click)="increment()">increment</button>
  <hr>
  <casi-ticker></casi-ticker>
  <hr>
  <casi-todo-component userId="-8"></casi-todo-component>
</div>
